/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-29 17:21:08
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-31 14:37:16
 */
import {
  Button,
  Modal,
  notification,
  Popover,
  Row,
  Space,
  TableColumnType,
  Tooltip,
} from 'antd'
import moment from 'moment'
import React, { ReactElement, useContext, useState, useEffect } from 'react'
import { EditableList } from '../../../compnents/list/EditableList'
import { DateTimeFormatSimple } from '../../../models/datetime'
import { ThemeContext } from '../../../theme/ThemeContext'
import styles from './Payments.module.css'

export const DetailModalList = (props?: {
  visible: boolean
  onOk: () => void
  onCancel: () => void
  detailList?: any
}): ReactElement => {
  const theme = useContext(ThemeContext)

  return (
    <Modal
      title='审核'
      destroyOnClose
      visible={props?.visible}
      onCancel={() => props?.onCancel()}
      footer={null}
      width={1000}
      className={styles.modal}
    >
      <Row style={{ fontSize: '1.125rem', color: theme.tc1 }}>
        <EditableList
          style={{
            marginTop: 12,
            marginLeft: 20,
            marginRight: 20,
            marginBottom: 20,
            flex: 1,
            overflow: 'auto',
          }}
          scroll={{ y: 400 }}
          pagination={false}
          dataSource={props?.detailList}
          bordered
          size='small'
          columns={
            [
              {
                title: '姓名',
                dataIndex: 'patientName',
                align: 'center',
                width: '5rem',
                ellipsis: true,
                render: (_, t) => (t.patientName ? t?.patientName : '-'),
              },
              {
                title: '就诊日期',
                dataIndex: 'treatmentTime',
                align: 'center',
                width: '5rem',
                ellipsis: true,
                render: (_, t) =>
                  t.treatmentTime
                    ? moment(t?.treatmentTime).format(DateTimeFormatSimple)
                    : '-',
              },
              {
                title: '就诊医生',
                dataIndex: 'doctorName',
                align: 'center',
                width: '5rem',
                ellipsis: true,
                render: (_, t) => (t.doctorName ? t?.doctorName : '-'),
              },
              {
                title: '门诊科室',
                dataIndex: 'department',
                align: 'center',
                width: '5rem',
                ellipsis: true,
                render: (_, t) => (t.department ? t?.department : '-'),
              },
              {
                title: '异常信息',
                dataIndex: 'errMsg',
                align: 'center',
                width: '20rem',
                render: function Element(_, t) {
                  return (
                    <Popover
                      content={
                        <>
                          <p
                            style={{
                              width:'500px',
                              fontSize: '16px',
                            }}
                          >
                            {t?.errMsg}
                          </p>
                        </>
                      }
                      placement='bottom'
                    >
                       <div style={{ width: '100%',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{t?.errMsg ? t?.errMsg : '-'}</div>
                    </Popover>
                  )
                },
              },
            ] as TableColumnType<any>[]
          }
        />
      </Row>
    </Modal>
  )
}
